module.exports = __webpack_public_path__ + "media/images/athletes/303-5b33d52036efc26c03a6ae2ed6c143fe.png";